<template>
    <div class="d-flex">
        <div class="d-inline-block bg-lighter radius-normal mr-3 image">
            <img v-if="image" :src="image">
        </div>

        <div class="info">
            <div class="timeline">
                {{ event.start | moment('dddd') }}, {{ event.start | moment('HH:mm') }} - {{ event.end | moment('HH:mm') }}
            </div>

            <h4 class="bold mt-1 mb-3">
                {{ product.name }}
            </h4>

            <div class="fs-small">
                <div class="available">
                    Available:

                    <span :class="(event.quantityAvailable < 3) ? 'color-6 bold' : ''">
                        {{ event.quantityAvailable }}/{{ event.maximumLotation }}
                    </span>
                </div>

                <ul>
                    <li v-if="event.eventNotes.length > 0" class="d-flex align-items-center my-1" v-for="note in event.eventNotes">
                        <i class="ico-alert largest color-6"></i>
                        {{ note.note }}
                    </li>
                </ul>

                <div class="logo p-4 bg-lighter">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props: {
            event: Object
        },
        computed: {
            product: function() {
                return this.event.product;
            },
            image: function() {
                return (this.product !== undefined && this.product.imageLogo) ? this.product.imageLogo : null;
            },
            location: function() {
                return this.product.locationCompleted;
            },
            transport: function() {
                return this.product.transport;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .image {
        width: 160px;
        height: 160px;
        overflow: hidden;

        > img {
            width: 160px;
            max-height: 160px;
        }
    }
</style>



// WEBPACK FOOTER //
// Event.vue?4236907b